<div [ngClass]="getAlertClass(alertType)" class="alert alert-dismissible alert-iconable-left fade show" role="alert">
    <ng-content></ng-content>
    <div class="alert-icon">
        <i [ngClass]="getAlertIconClass(alertType)"></i>
    </div>
</div>
